/**
 * Determines if the 'fromEmail' query parameter is set to 'true'.
 * @param urlParams - URLSearchParams object representing the URL query parameters.
 * @returns {boolean} True if 'fromEmail' is 'true', otherwise false.
 */
export const isEmailSourceInQueryParams = (urlParams: URLSearchParams): boolean => {
  return urlParams.get('fromEmail') === 'true'
}
